import React from 'react';
import { Layout, theme } from 'antd';
import './styles/content.scss';
import Fondo from '@/icons/fondo-1';

const { Content } = Layout;

type Props = {
  children: React.ReactNode;
};

const DashboardContent: React.FC<Props> = (props: Props) => {
  return (
    <Content>
      {/* <Fondo className="svg-background" /> */}
      {props.children}
    </Content>
  );
};

export default DashboardContent;
